import { GoogleLogin } from "@react-oauth/google";
import React from "react";
export default function LoginButton({ onSuccess }) {
  return (
    <GoogleLogin
      onSuccess={(credentialResponse) => {
        onSuccess(credentialResponse.credential);
      }}
      onError={() => {
        console.log("Login Failed");
      }}
    />
  );
}
